import CustomChartBar from '../../../../utils/CustomChartBar';
import { Box, Typography } from '@mui/material';
import '../../../../css/machines/machineInvoiceChart.css';

const MachineInvoiceChart = ({ machineDetailsData }) => {

    const expenseByYear = machineDetailsData?.machine_expense.reduce((acc, expense) => {
        const year = new Date(expense.invoice_detail.invoice.date).getFullYear(); // Extract year from created_at
        if (!acc[year]) {
            acc[year] = 0; // Initialize the year with 0 amount
        }
        acc[year] += expense.amount; // Add the amount to the corresponding year
        return acc;
    }, {});

    const years = Object.keys(expenseByYear);
    const amounts = Object.values(expenseByYear);

    return (
        <Box className='machineInvoiceChart_main_box'>
            <Typography className='machineInvoiceChart_title'>Montant des Factures</Typography>
            <CustomChartBar years={years} amounts={amounts} />
        </Box>
    )
}

export default MachineInvoiceChart